import { Navigate, useParams } from 'react-router-dom';

/** Legacy route — content lives on the information-desk page. */
export default function LocationAboutPage() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/${slug}/information-desk`} replace />;
}
